export default __webpack_public_path__ + "1c3697abb4f853c6258b4d4bff643dfe.png";